import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { purple } from '@material-ui/core/colors';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import { Grid, TextField, InputAdornment, Select, MenuItem } from '@material-ui/core';

const tema = createMuiTheme({
  palette: {
    primary: {
      main: purple['A200']
    }
  },
  typography: {
    fontFamily: 'CircularStd-Book'
  }
});

const TextoESelect = props => {
  const classes = useStyles(props);
  const {
    onChangeUnidade,
    campoRequerido,
    tamanhoMaximo,
    opcoesSelect,
    desabilitado,
    className,
    onChange,
    tabIndex,
    unidade,
    label,
    valor,
    id
  } = props;

  const [focusOut, setStateFocusOut] = useState(false);
  const [erroComportamento, setErroComportamento] = useState(false);

  useEffect(() => {
    const erroPorCampoObrigatorio = campoRequerido && focusOut && !valor;
    setErroComportamento(erroPorCampoObrigatorio);
  }, [campoRequerido, focusOut, valor]);

  const limitarTamanhoInput = (event) => {
    if (tamanhoMaximo) {
      event.target.value = Math.max(0, parseInt(event.target.value)).toString().slice(0, tamanhoMaximo);
    }
  }

  return (
    <Grid container>
      <Grid item xs={12} onFocus={() => setStateFocusOut(false)}>
        <ThemeProvider theme={tema}>
          <TextField
            onBlur={() => setStateFocusOut(true)}
            onInput={limitarTamanhoInput}
            disabled={desabilitado}
            error={erroComportamento}
            className={className}
            label={label}
            required={campoRequerido}
            onChange={onChange}
            variant="outlined"
            value={valor}
            type="number"
            min={0}
            id={id}
            InputProps={{
              inputProps: { tabIndex: tabIndex },
              endAdornment: (
                <InputAdornment position="end" >
                  <Select
                    id='unidade'
                    className={classes.unidade}
                    disableUnderline
                    onBlur={() => setStateFocusOut(true)}
                    disabled={desabilitado}
                    value={unidade}
                    onChange={onChangeUnidade}
                    inputProps={{ tabIndex: tabIndex }}
                  >
                    {opcoesSelect.map((opcao) => {
                      return (
                        <MenuItem key={opcao.codigo} value={opcao.codigo}>
                          {opcao.descricao}
                        </MenuItem>
                      )
                    })
                    }
                  </Select>
                </InputAdornment>
              ),
            }}
          />
        </ThemeProvider>
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles({
  unidade: {
    borderLeft: '0.05em solid #b5b5b5',
    paddingLeft: '0.8em'
  }
});

TextoESelect.propTypes = {
  onChangeUnidade: PropTypes.func.isRequired,
  opcoesSelect: PropTypes.array.isRequired,
  unidade: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  valor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tamanhoMaximo: PropTypes.number,
  campoRequerido: PropTypes.bool,
  desabilitado: PropTypes.bool,
  className: PropTypes.string,
  tabIndex: PropTypes.number,
  label: PropTypes.string,
  id: PropTypes.string
};

TextoESelect.defaultProps = {
  campoRequerido: true,
  desabilitado: true,
  opcoesSelect: {},
  tamanhoMaximo: 0,
  className: '',
  tabIndex: 0,
  unidade: '',
  label: '',
  valor: 0,
  id: ''
};

export default TextoESelect;